export default "__VITE_ASSET__3d54447d__"